<script lang="ts" et-landing-template>
    import { defineComponent, type PropType, ref } from 'vue';

    import { useServiceContainer } from '~/container';

    import type { ArticleBarChartData } from '~/modules/landing/interfaces';

    import { getArticleBarChartRatios } from '~/modules/landing/utils/getArticleBarChartRatios';
    import { readArticleBarChartFromData } from '~/modules/landing/utils/readArticleBarChartData';

    export default defineComponent({
        template: '#landingEtArticleBarChart',
        props: {
            chart: {
                type: Object as PropType<ArticleBarChartData>,
                required: true,
            },
        },
        setup(props) {
            const { NumberHelperService } = useServiceContainer();

            const { title, subtitle, bars } = readArticleBarChartFromData(
                props.chart,
                NumberHelperService.locale.replace('_', '-'),
            );
            const ratios = getArticleBarChartRatios(bars);
            const longestValueLength = Math.max(0, ...bars.map((bar) => bar.value.length));
            const revealed = ref(false);

            function reveal() {
                revealed.value = true;
            }

            return {
                title,
                subtitle,
                bars,
                longestValueLength,
                ratios,
                revealed,
                reveal,
            };
        },
    });
</script>
